import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	// Route,
	// Switch,
	// Link,
} from 'react-router-dom';
import Lottie from 'react-lottie';
import * as loadingAnimationData from './assets/json/lottie-coffee-cup.json';
import Hero from './components/Hero';
import Story from './components/Story';
import Menu from './components/Menu';
import Hours from './components/Hours';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

class App extends Component {
	state = {
		error: null,
		isLoaded: false,
		site_info: [],
		didMount: false,
	};

	async componentDidMount() {
		//   console.log(process.env);
		//   const url = `${process.env.REACT_APP_COCKPIT_URL}/cockpit/api/singletons/get/site_info?token=${process.env.REACT_APP_COCKPIT_TOKEN}`;
		//   console.log(`${url}`);
		try {
			const res = await fetch(
				`${process.env.REACT_APP_COCKPIT_URL}/cockpit/api/singletons/get/site_info?token=${process.env.REACT_APP_COCKPIT_TOKEN}`
			);
			const result = await res.json();
			console.log(result);
			this.setState({
				isLoaded: true,
				site_info: result,
			});
			if (this.state.site_info.text_style === 'Style 1') {
				document.body.classList.add('theme1');
			} else {
				document.body.classList.add('theme2');
			}
		} catch (e) {
			console.log(`error: ${e}`);
		}
		setTimeout(() => {
			this.setState({ didMount: true })
		}, 0)
	}

	render() {
		const { error, isLoaded, didMount } = this.state;
		const defaultOptions = {
			loop: true,
			autoplay: true,
			animationData: loadingAnimationData.default, // MUST INCLUDE '.default' to work
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice'
			}
		};
		if (error) {
			return <div>Error: {error.message}</div>;
		}
		if (!isLoaded) {
			return (
			<div id="loading-wrapper">
					<div className="loader">
						<Lottie options={defaultOptions}
              height={100}
              width={100}/>
				</div>
			</div>
			);
		}
		return (
			<Router>
				<div id="wrapper" className={`fade-in ${didMount && 'visible'}`}>
					<Hero site_info={this.state.site_info} />
					<Story site_info={this.state.site_info} />
					<Menu />
					<Hours />
					<Gallery gallery={this.state.site_info.gallery} />
					<Footer site_info={this.state.site_info} />
				</div>
			</Router>
		);
	}
}

export default App;
